import { jsx as t, jsxs as b } from "react/jsx-runtime";
import { Dropdown as d } from "../../shared/dropdown/Dropdown.component.js";
import { T as c } from "../../index-DwB8CbmG.js";
import { useCallback as m, Fragment as v } from "react";
import { FlowsAddButton as K } from "../add-button/AddButton.component.js";
import { Trigger as h } from "./Trigger.component.js";
import { TriggerForm as a } from "./TriggerForm.component.js";
import { useMergeThemeVariables as f } from "../../shared/utils.js";
import '../../assets/Triggers.css';const j = "_triggers_1p33f_2", w = "_triggersLabel_1p33f_11", x = "_booleanOperator_1p33f_20", i = {
  triggers: j,
  triggersLabel: w,
  booleanOperator: x
}, A = ({
  copies: g,
  declaration: e,
  onFlowDeclarationUpdate: o,
  apiDeclaration: n,
  theme: T
}) => {
  const l = f(
    "dropdown",
    d.themeKeys,
    T
  ), u = f(
    "trigger",
    h.themeKeys,
    T
  ), p = m(
    (r) => {
      const s = Object.keys(e.triggers).length;
      o({
        ...e,
        triggers: {
          ...e.triggers,
          [`trigger${s}`]: r
        }
      });
    },
    [e, o]
  ), _ = m(
    (r) => {
      const { [r]: s, ...L } = e.triggers;
      o({
        ...e,
        triggers: L
      });
    },
    [e, o]
  ), y = m(
    (r) => /* @__PURE__ */ t(K, { ...r, copy: g.add }),
    [g]
  ), O = m(
    (r) => /* @__PURE__ */ t(
      a,
      {
        ...r,
        copies: g,
        onAddTrigger: p,
        apiDeclaration: n,
        declaration: e
      }
    ),
    [n, g, p, e]
  );
  return /* @__PURE__ */ b("div", { className: i.triggers, children: [
    /* @__PURE__ */ t("div", { className: i.triggersLabel, children: g.label }),
    Object.entries(e.triggers).map(
      ([r, s]) => s.variant === c.SCHEDULE ? /* @__PURE__ */ t("div", {}, r) : /* @__PURE__ */ b(v, { children: [
        /* @__PURE__ */ t(
          h,
          {
            theme: u,
            copies: g,
            apiDeclaration: n,
            triggerId: r,
            trigger: s,
            onDelete: _
          }
        ),
        /* @__PURE__ */ t("div", { className: i.booleanOperator, children: g.or })
      ] }, r)
    ),
    /* @__PURE__ */ t(
      d,
      {
        theme: l,
        renderButton: y,
        renderMenuContent: O,
        topPlateOffset: 10
      }
    )
  ] });
}, C = A;
C.themeKeys = {
  ...d.themeKeys,
  ...h.themeKeys,
  dropdown: !0,
  trigger: !0
};
export {
  C as Triggers
};
